export async function fieldFinance(token, path, { signal, body } = {}) {
  const response = await fetch(`/api/${path}`, { method: body === undefined ? 'GET' : 'POST', signal, cache: 'no-store',
    headers: { 'X-Session-Token': token, ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }) });
  const data = await response.json();
  if (!response.ok) throw new Error(data.error || 'دریافت اطلاعات ناموفق بود.');
  return data;
}
